import PlayCircleFilledTwoToneIcon from "@mui/icons-material/PlayCircleFilledTwoTone";
import PauseCircleFilledTwoToneIcon from "@mui/icons-material/PauseCircleFilledTwoTone";
import { Box, Button, useMediaQuery } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import { isEmpty } from "lodash";
import { useRouter } from "next/router";
import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { API_BASE_URL } from "../../src/constant/appConstants";
import fetcher from "../../src/dataProvider";
import eventBus from "../../util/eventBus";
import { songPageGTMCTAClick } from "../../util/gtmutil";
import auth from "../Layout/util/auth";
import get from "loadsh/get";

const useStyles = makeStyles(() => ({
  LaunchedNft__Details: {
    padding: "60px 0",
    // height: "1200px",
    overflow: "hidden",
    position: "relative",
    "@media (max-width:1024px)": {
      height: "1100px",
    },
    "@media (max-width:1023px)": {
      height: "1900px",
    },
    "@media (max-width:767px)": {
      height: "1580px",
      padding: "0",
    },
    "& .LaunchedNft__Conatiner": {
      width: "1400px",
      margin: "auto",
      "@media (max-width:1500px)": {
        width: "100%",
      },
      "@media (max-width:1024px)": {
        width: "100%",
      },
      "@media (max-width:767px)": {
        width: "100%",
      },
      "& .custom__grid": {
        "@media (max-width:1024px)": {
          maxWidth: "50%",
        },
        "@media (max-width:767px)": {
          maxWidth: "100%",
        },
      },
    },

    "& h1": {
      color: "#fff",
      fontSize: "60px",
      marginBottom: "60px",
      fontWeight: "900",
      "@media (max-width:767px)": {
        fontSize: "25px",
      },
    },
    "& .LaunchedNft__ItemsDetails": {
      background: "rgb(255,195,220)",
      background:
        "linear-gradient(90deg, rgba(255,195,220,1) 0%, rgba(193,196,255,1) 100%)",
      borderRadius: "10px",
      padding: "5px",
      position: "relative",
      marginBottom: "50px",
      // -webkit-transition: bottom 0.5s ease;
      transition: "bottom 0.5s ease",
    },
  },
  Nft__Card: {
    position: "relative",
    "& img": {
      borderRadius: "5px",
      width: "100%",
      objectFit: "cover",
    },
    "& .Fan__SongName": {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "280px",
    },
  },
  Nft__CardDetails: {
    position: "absolute",
    bottom: "10px",
    // backgroundImage:"linear-gradient(to right, #E14084 0%, #3454FA 53.16%, #54B5BB 100%)",
    borderRadius: "10px",
    borderRadius: "10px",
    left: "7px",
    right: "7px",
    margin: "auto",
    "& .Nft__allDetails": {
      padding: "23px 18px",
      transition: "bottom 0.5s ease",
      position: "relative",
      zIndex: "9",
      fontSize: "46px",
      borderRadius: "8px",
      backdropFilter: "blur(11px)",
      background: "rgb(0 0 0 / 58%)",
      boxShadow: "2px 1000px 1px #000000f5 inset",
      border: "solid 2px transparent",
      background:
        "linear-gradient(93.2deg, #E14184 0%, #3555FA 55.26%, #55B5BB 97.94%)",
      backgroundOrigin: "border-box",

      "@media (max-width:398px)": {
        padding: "10px 10px",
      },

      "& p": {
        fontSize: "13px",
        color: "#fff",
        marginBottom: "8px",
      },
      "& h3": {
        fontSize: "23px",
        color: "#fff",
        fontWeight: "bold",
        lineHeight: "19px",
        "@media (max-width:767px)": {
          fontSize: "20px",
        },
        "@media (max-width:398px)": {
          fontSize: "13px",
        },
      },
      "& .play__Icon": {
        position: "absolute",
        left: "50%",
        textAlign: "center",
        transform: "translateX(-50%)",
        top: "-28px",
        color: "#fff",
        cursor: "pointer",
      },
      "& .play__Icon.open__fanIcon": {
        position: "inherit",
        width: "100px",
        height: "0",
        textAlign: "left",
        top: "10px",
        left: "-5px",
      },
    },
  },
  buy__Option: {
    fontSize: "12px",
    color: "#fff",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "& h3": {
      fontSize: "20px !important",
    },
  },
  left__sideoption: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",

    "& .down__Price": {
      "& img": {
        width: "12px",
      },
      "& p": {
        color: "#ff0000",
        "@media (max-width:767px)": {
          fontSize: "11px",
        },
        "& span": {
          float: "left",
          marginRight: "5px",
        },
      },
    },
  },
  right__sideoption: {
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
    "& img": {
      width: "78px",
      height: "39px",
    },
    "& Button": {
      height: "39px",
      color: "#fff",
      padding: "8px 19px",
      fontSize: "14px",
      borderRadius: "45px",
      marginLeft: "10px",
      textAlign: "center",
      border: "1px solid #fff",
      width: "70px",
      "&:hover": {
        backgroundColor: "#fff",
        color: "#000",
        border: "1px solid #fff",
      },
    },
  },
  featuredBuyNow: {
    position: "relative",
    textAlign: "center",
    display: "block",
    fontWeight: "600",
    // width: "100%",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    // marginTop: "20px",
    borderRadius: "100px !important",
    height: "46px",
    color: "#fff !important",
    // paddingTop: "15px",
    textDecoration: "none",
    cursor: "pointer",
    textTransform: "capitalize",
    border: "none !important",
    "&:hover": {
      color: "#fff",
      textDecoration: "none",
      border: "none !important",
    },
  },

  User__list: {
    listStyle: "none",
    width: "35%",
    "& ul": {
      marginBottom: "0px",
      padding: "0",
      textAlign: "right",
      display: "flex",
      justifyContent: "right",
      "& li": {
        display: "inline-block",
        marginLeft: "-7px",
      },
    },
    "& img": {
      width: "24px !important",
      height: "24px !important",
      border: "2px solid #fff !important",
      borderRadius: "100px",
    },
  },
  fanArrow__icon: {
    position: "absolute",
    left: "0",
    right: "0",
    textAlign: "center",
    bottom: "-13px",
    zIndex: 9,
    cursor: "pointer",
  },
  fan__pricechart: {
    marginTop: "30px",
    "@media (max-width:767px)": {
      marginTop: "20px",
    },
    "& h1": {
      fontSize: "16.74px",
      fontWeight: "600",
      textAlign: "center",
      marginTop: "10px !important",
      marginBottom: "10px !important",
    },

    "& img": {
      // height: "295px",
      objectFit: "fill !important",
      "@media (max-width:767px)": {
        height: "209px",
      },
    },
  },
  fan__SongOpen: {
    width: "165px",
    margin: "auto",
    "@media (max-width:767px)": {
      width: "120px",
    },
  },
  all_NFT: {
    cursor: "pointer",
    position: "absolute",
    bottom: "30px",
    left: "0",
    right: "0",
    zIndex: "33",
    color: "#FFF",
    textAlign: "center",
    margin: "auto",
    maxWidth: "177px",
    padding: "18px",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB)",
    borderRadius: "100px",

    "&:hover": {
      background:
        "linear-gradient(90deg, rgba(52,84,250,0.9139005944174545) 33%, rgba(225,64,132,0.8102591378348214) 77%) !important",
      boxShadow: "0px 0px 31px 3px #3659f6",
    },
    "@media (max-width:480px)": {
      position: "inherit",
      marginBottom: "35px",
    },
  },
  all_NFTHide: {
    "&:after": {
      content: "''",
      position: "absolute",
      bottom: "0px",
      width: "100%",
      left: "0",
      right: "0",
      height: "300px",
      zIndex: "11",
      // background: "url(/images/newHome/Rectanglebg.svg)",
      background:
        "transparent linear-gradient(0deg,#0c091b 38%,transparent 96%) repeat scroll 0 0",
      "@media (max-width:1367px)": {
        bottom: "-3px",
      },
      "@media (max-width:767px)": {
        height: "420px",
      },
    },
  },
  featuredCardTitle: {
    fontWeight: "400",
    fontSize: "24px",
    color: "#fff",
    "@media (max-width:767px)": {
      fontSize: "20px",
    },
    "@media (max-width:480px)": {
      fontSize: "18px",
    },
  },
  graphBox: {
    position: "relative",
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "380px",
    borderRadius: "10px",
    "@media(max-width:480px)": {
      width: "100%",
    },
  },
  nftStatus: {
    position: "relative",
    display: "block",
    width: "100%",
    padding: "24px 15px",
    background: "rgba(255, 255, 255, 0.05)",
    borderRadius: "10px",
    height: "325px",
    marginBottom: "23px",
  },

  buyPrice: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    color: "#fff",
    fontSize: "15px",
    fontWeight: "400",
    "& > div": {
      position: "relative",
      display: "flex",
      alignItems: "center",
      "& span": {
        position: "relative",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        marginLeft: "3px",
        "& img:last-child": {
          marginTop: "3px",
        },
      },
      "& ul": {
        position: "relative",
        display: "flex",
        alignItems: "center",
        "& li": {
          padding: "6px",
          cursor: "pointer",
          "&.active": {
            background: "#FFF",
            color: "#000",
            borderRadius: "8px",
          },
        },
      },
    },
  },
  priceValue: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    color: "#fff",
    fontSize: "16px",
    fontWeight: "700",
    width: "100%",
    "& span": {
      fontSize: "16px",
      fontWeight: "400",
      marginLeft: "10px",
      display: "block",
      "&:before": {
        content: "''",
        position: "relative",
        display: "inline-block",
        width: "1px",
        left: "-3px",
      },
      "&.up": {
        color: "#54B5BB",
        "&.up:before": {
          borderBottom: "9px solid #54B5BB",
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderTop: "6px solid transparent",
        },
      },
      "&.down": {
        color: "red",
        "&.down:before": {
          borderBottom: "6px solid transparent",
          borderLeft: "6px solid transparent",
          borderRight: "6px solid transparent",
          borderTop: "9px solid red",
          top: "3px",
        },
      },
    },
  },
  highLow: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginTop: "14px",
    "& p": {
      color: "#C5C4C9",
      fontSize: "12px",
      fontWeight: "400",
      "& span": {
        color: "#fff",
        marginLeft: "3px",
      },
    },
  },
  linkCalculator: {
    position: "relative",
    display: "block",
    color: "#E94177 ",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
  },
  allNftCardOpen: {
    height: "auto",
  },
  all_NFThide: {
    display: "none",
  },
}));

const LaunchedNft = ({ LaunchedNftSongvalue }) => {
  const r = auth();
  const router = useRouter();
  const classes = useStyles();
  const dispatch = useDispatch();
  const audioPlayRef = useRef();
  const [data1, setData] = useState();
  const [openAllCard, setOpenAllCard] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSongplay, setIsSongPlay] = useState(false);
  const [isNftSong, setIsNftSong] = useState(false);
  const isMobile = useMediaQuery("(max-width:768px)");
  const [featureSongvalue, setFeatureSongvalue] =
    useState(LaunchedNftSongvalue);
  console.log(LaunchedNftSongvalue?.sort((a, b) => b?.id - a?.id));
  const { country_code } = useSelector((state) => state.layout);
  const { userData } = useSelector((state) => state?.user);

  const handleMoredetails = (data, type = "Image") => {
    songPageGTMCTAClick(
      r,
      type,
      "featured drops",
      type,
      "loggedIn",
      "Guest",
      data?.attributes?.Title
    );
    router.push(data?.attributes?.nft_slug);
  };

  if (typeof window !== "undefined") {
    localStorage.setItem("songId", data1?.id);
  }

  function togglePlay(songID, type) {
    const currentSongId = get(audioPlayRef, "current", null);
    if (currentSongId != null) {
      if (currentSongId != songID) {
        var prevAudio =
          typeof window != "undefined" &&
          document?.getElementById(currentSongId);
        if (!prevAudio?.paused) prevAudio?.pause();
      }
    }
    console.log("🚀 ~ file: LaunchedNft.js:532 ~ togglePlay ~ type", type);
    setIsSongPlay(!isSongplay);
    audioPlayRef.current = songID;
    setIsNftSong((audioPlayRef.current = songID));
    var myAudio =
      typeof window != "undefined" && document?.getElementById(songID);
    if (type == "pause") {
      setIsSongPlay(false);
    } else if (type == "play") {
      setIsSongPlay(true);
    }
    return myAudio?.paused ? myAudio?.play() : myAudio?.pause();
  }

  const NFTCollector = (item) => {
    return (
      <div className={classes.User__list}>
        <ul>
          {item?.slug &&
            item?.slug?.map((item, index) => {
              return (
                <li key={item?.user?._id}>
                  <img
                    src={item?.user?.profilePic}
                    alt="collectors"
                    style={{ width: "10px", height: "10px", display: "flex" }}
                  />
                </li>
              );
            })}
        </ul>
      </div>
    );
  };

  const handleBuyNft = (item) => {
    songPageGTMCTAClick(
      r,
      "ctaClicks",
      "Home Buy NFT",
      "Buy now",
      "loggedIn",
      "Guest",
      "slug"
    );
    if (typeof window != "undefined") {
      localStorage.setItem("nftAction", "BuyNFT");
      localStorage.setItem("is_tradable", true);
      localStorage.setItem("tokenName", "Title");
      localStorage.setItem(
        "tierId",
        item?.attributes?.asset_tiers?.data?.[0]?.attributes?.tier_id
      );
      localStorage.setItem("tokenCategory", item?.attributes?.meta_og_url);
      localStorage.setItem("tokenPrice", item?.attributes?.tradingPrice);
    }
    if (isEmpty(r?.token)) {
      eventBus?.dispatch("openLoginModal", {
        function_name: "uniqueCommunity",
      });
    } else if (!userData?.mobile) {
      eventBus?.dispatch("openCapturePhoneModal", {
        function_name: "capturephone",
      });
    } else {
      router?.push({
        pathname: "/payment/BuyTradeNft",
        query: {
          tier_id:
            item?.attributes?.asset_tiers?.data?.[0]?.attributes?.tier_id,
        },
      });
    }
  };
  const handleSellNft = async (item) => {
    songPageGTMCTAClick(
      r,
      "ctaClicks",
      "Thumbnail",
      "Sell now",
      "loggedIn",
      "Guest",
      "slug"
    );

    localStorage.setItem("nftAction", "SellNFT");
    if (isEmpty(r?.token)) {
      eventBus.dispatch("openLoginModal", {
        function_name: "uniqueCommunity",
      });
    } else if (!userData?.mobile) {
      eventBus.dispatch("openCapturePhoneModal", {
        function_name: "capturephone",
      });
    } else {
      let id = userData?.id;
      let slug = item?.attributes?.meta_og_url;
      let data = await fetcher.get(
        `${API_BASE_URL}/v1/user/${id}/check-nft-purchase?slug=${slug}`
      );
      if (data?.hasNft) {
        router.push({
          pathname: "/payment/SellTradeNft",
          query: {
            tier_id:
              item?.attributes?.asset_tiers?.data?.[0]?.attributes?.tier_id,
          },
        });
      } else {
        alert("You don't have NFT to Sell");
      }
    }
  };

  return (
    <>
      <section
        style={{ height: openAllCard ? "auto" : "1200px" }}
        className={classes.LaunchedNft__Details}
      >
        <Container maxWidth="xl">
          <Typography variant="h1" textAlign={"center"}>
            LAUNCHED NFT’s
          </Typography>
          <Box className="LaunchedNft__Conatiner" sx={{ width: "100%" }}>
            <Grid
              direction="row"
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              {featureSongvalue?.length > 0 &&
                featureSongvalue?.map((item) => {
                  return (
                    <Grid
                      className="custom__grid"
                      item
                      md={4}
                      xs={12}
                      key={item?.id}
                    >
                      <Box className="LaunchedNft__ItemsDetails">
                        <Box className={classes.Nft__Card}>
                          <img
                            src={
                              item?.attributes.additional_media_image.data[0]
                                .attributes.formats.small.url
                            }
                            style={{ height: "500px", cursor: "pointer" }}
                            alt="song Nft image"
                            onClick={() => handleMoredetails(item, "Image")}
                          />
                          <Box className={classes.Nft__CardDetails}>
                            <Box
                              className={
                                isExpanded === item?.id + 1
                                  ? "Nft__allDetails openHeight"
                                  : "Nft__allDetails"
                              }
                            >
                              <Box
                                className="allopenDetails"
                                style={{
                                  display:
                                    isExpanded === item?.id + 1
                                      ? "block"
                                      : "none",
                                }}
                              >
                                <Box className={classes.fan__SongOpen}>
                                  <Typography variant="h3">
                                    {item?.attributes?.meta_name}
                                  </Typography>
                                </Box>
                              </Box>

                              <Box className="play__Icon">
                                <audio
                                  id={item?.id}
                                  preload="auto"
                                  src={item?.attributes?.audio_url}
                                  ref={audioPlayRef}
                                ></audio>
                                {console.log(
                                  "🚀 ~ file: LaunchedNft.js:710 ~ LaunchedNft ~ isSongplay",
                                  isSongplay,
                                  isNftSong,
                                  item?.id
                                )}
                                {isNftSong === item?.id && isSongplay ? (
                                  <PauseCircleFilledTwoToneIcon
                                    sx={{ fontSize: 45 }}
                                    onClick={() => {
                                      togglePlay(item?.id, "pause");
                                    }}
                                  />
                                ) : (
                                  <PlayCircleFilledTwoToneIcon
                                    sx={{ fontSize: 45 }}
                                    onClick={() => togglePlay(item?.id, "play")}
                                  />
                                )}
                              </Box>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "self-start",
                                  marginBottom: "20px",
                                }}
                              >
                                <Box>
                                  <Typography variant="h3">
                                    {item?.attributes?.Title}
                                  </Typography>
                                  <p
                                    style={{
                                      paddingTop: "8px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      router?.push(
                                        `/artist/${item?.attributes?.artists?.data[0]?.attributes?.slug}`
                                      );
                                    }}
                                  >
                                    by{" "}
                                    {
                                      item?.attributes?.artists?.data[0]
                                        ?.attributes?.name
                                    }
                                  </p>
                                </Box>
                                {/* NFt collector  */}
                                <NFTCollector
                                  slug={
                                    item?.attributes?.priceDetail?.collectors ||
                                    []
                                  }
                                />
                              </Box>
                              <Box className={classes.buy__Option}>
                                <Box className={classes.left__sideoption}>
                                  {item?.attributes?.is_tradable ? (
                                    <Box className="current__Price">
                                      <p>Current Price:</p>
                                      <Typography variant="h3">
                                        {country_code == "IN" && (
                                          <Typography
                                            variant="h3"
                                            className={
                                              classes.featuredCardTitle
                                            }
                                          >
                                            ₹
                                            {Math.round(
                                              item?.attributes?.priceDetail
                                                ?.currentPrice * 80
                                            )}
                                          </Typography>
                                        )}
                                        {country_code == "OTHER" && (
                                          <Typography
                                            variant="h3"
                                            className={
                                              classes.featuredCardTitle
                                            }
                                          >
                                            $
                                            {
                                              item?.attributes.priceDetail
                                                ?.currentPrice
                                            }
                                          </Typography>
                                        )}
                                      </Typography>
                                    </Box>
                                  ) : (
                                    <p>
                                      <Box className="current__Price">
                                        <p>Price Range</p>
                                        {item?.attributes
                                          ?.ticketing_nft_lowest_price ? (
                                          <Typography variant="h3">
                                            {country_code == "IN" && (
                                              <Typography
                                                variant="h3"
                                                className={
                                                  classes.featuredCardTitle
                                                }
                                              >
                                                ₹
                                                {Math.round(
                                                  item?.attributes
                                                    .ticketing_nft_lowest_price *
                                                    80
                                                )}{" "}
                                                - ₹
                                                {Math.round(
                                                  item?.attributes
                                                    .ticketing_nft_highest_price *
                                                    80
                                                )}
                                              </Typography>
                                            )}
                                            {country_code == "OTHER" && (
                                              <Typography
                                                variant="h3"
                                                className={
                                                  classes.featuredCardTitle
                                                }
                                              >
                                                $
                                                {
                                                  item?.attributes
                                                    .ticketing_nft_lowest_price
                                                }{" "}
                                                - $
                                                {
                                                  item?.attributes
                                                    .ticketing_nft_highest_price
                                                }
                                              </Typography>
                                            )}
                                          </Typography>
                                        ) : (
                                          <Typography variant="h3">
                                            {country_code == "IN" && (
                                              <Typography
                                                variant="h3"
                                                className={
                                                  classes.featuredCardTitle
                                                }
                                              >
                                                ₹
                                                {Math.round(
                                                  item?.attributes.lowest_ask *
                                                    80
                                                )}{" "}
                                                - ₹
                                                {Math.round(
                                                  item?.attributes.highest_ask *
                                                    80
                                                )}
                                              </Typography>
                                            )}
                                            {country_code == "OTHER" && (
                                              <Typography
                                                variant="h3"
                                                className={
                                                  classes.featuredCardTitle
                                                }
                                              >
                                                ${item?.attributes.lowest_ask} -
                                                ${item?.attributes.highest_ask}
                                              </Typography>
                                            )}
                                          </Typography>
                                        )}
                                      </Box>
                                    </p>
                                  )}

                                  {item?.attributes?.is_tradable && (
                                    <>
                                      {item?.attributes?.priceDetail
                                        ?.changePercent24Hr == 0 ? (
                                        <Box className="down__Price"></Box>
                                      ) : item?.attributes?.priceDetail
                                          ?.changePercent24Hr > 0 ? (
                                        <Box className="down__Price">
                                          <p style={{ color: "#03ff00" }}>
                                            <span>
                                              <img
                                                src={
                                                  "/images/fantv/green-arrow.gif"
                                                }
                                                alt="Up arrow gif"
                                                style={{
                                                  marginTop: "-6px",
                                                  transform: "rotate(181deg)",
                                                }}
                                              />
                                            </span>
                                            {Math.abs(
                                              item?.attributes?.priceDetail
                                                ?.changePercent24Hr
                                            ).toFixed(2)}
                                            %
                                          </p>
                                        </Box>
                                      ) : item?.attributes?.priceDetail
                                          ?.changePercent24Hr < 0 ? (
                                        <Box className="down__Price">
                                          <p>
                                            <span>
                                              <img
                                                src={
                                                  "/images/fantv/red-arrow.gif"
                                                }
                                                alt="Up arrow gif"
                                              />
                                            </span>
                                            {Math.abs(
                                              item?.attributes?.priceDetail
                                                ?.changePercent24Hr
                                            ).toFixed(2)}
                                            %
                                          </p>
                                        </Box>
                                      ) : null}
                                    </>
                                  )}
                                </Box>
                                {item?.attributes?.is_tradable ? (
                                  <Box className={classes.right__sideoption}>
                                    <Button
                                      className={classes.featuredBuyNow}
                                      variant="outlined"
                                      style={{ border: "none" }}
                                      onClick={() => handleBuyNft(item)}
                                    >
                                      Buy
                                    </Button>
                                    <Button
                                      variant="outlined"
                                      onClick={() => handleSellNft(item)}
                                    >
                                      Sell
                                    </Button>
                                  </Box>
                                ) : (
                                  <Button
                                    variant="outlined"
                                    className={classes.featuredBuyNow}
                                    onClick={() =>
                                      router.push(item?.attributes?.nft_slug)
                                    }
                                  >
                                    More Details
                                  </Button>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </Box>
                      </Box>
                    </Grid>
                  );
                })}
            </Grid>
            <Box className={openAllCard ? "" : classes.all_NFTHide}>
              <Box
                className={classes.all_NFT}
                style={{
                  position: isMobile && openAllCard ? "inherit" : "absolute",
                }}
                onClick={() => setOpenAllCard(!openAllCard)}
              >
                {openAllCard ? "Load Less" : "Load More"}
              </Box>
            </Box>
          </Box>
        </Container>
      </section>
    </>
  );
};
export default LaunchedNft;
